import React from 'react';

import { Toggle } from 'components';

import Dropdown from 'components/form/Dropdown';
import { M, S } from 'components/typography';
import { convertTo62 } from 'uuid-encoding';
import styles from './styles.scss';

export type ChargeCodeToggleSectionProps = {
  isEnabled: boolean;
  onToggle: () => void;
  chargeCodeId: string | null;
  onChargeCodeChange: (option: { value: string }) => void;
  chargeCodeOptions: { label: string; value: string }[];
  toggleLabel: string;
  toggleDescription: string;
  chargeCodeLabel: string;
  chargeCodePlaceholder: string;
  toggleTestId: string;
  dropdownTestId: string;
};

export function ChargeCodeToggleSection({
  isEnabled,
  onToggle,
  chargeCodeId,
  onChargeCodeChange,
  chargeCodeOptions,
  toggleLabel,
  toggleDescription,
  chargeCodeLabel,
  chargeCodePlaceholder,
  toggleTestId,
  dropdownTestId,
}: ChargeCodeToggleSectionProps) {
  return (
    <div className={styles.BillingReportToggleContainer}>
      <Toggle value={isEnabled} onChange={onToggle} testId={toggleTestId} />
      <div className={styles.BillingReportToggleDescription}>
        <M mt={2} className={styles.FieldLabel}>
          <label>{toggleLabel}</label>
        </M>
        {isEnabled && (
          <>
            <M mt={2} className={styles.FieldLabel}>
              <S>{toggleDescription}</S>
            </M>
            <div className={`${styles.SectionContainer} mt-2`}>
              <div className={styles.ChargeCodeLabelContainer}>
                <M className={styles.FieldLabel}>
                  <label>{chargeCodeLabel}</label>
                </M>
              </div>
              <div className={styles.ChargeCodeDropdownContainer}>
                <Dropdown
                  className={styles.ChargeCodeDropdown}
                  value={chargeCodeId ? convertTo62(chargeCodeId) : ''}
                  items={chargeCodeOptions}
                  onChange={onChargeCodeChange}
                  placeholder={chargeCodePlaceholder}
                  testId={dropdownTestId}
                  doTranslation={false}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
